import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ErrorModal } from './shared/components/error-modal/error-modal';

@Component({
  selector: 'h2j-root',
  imports: [RouterOutlet, ErrorModal],
  template: `<router-outlet /><h2j-error-modal-host />`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
